import { getIsMobile } from '@bridebook/web/app-basic/lib/app/selectors';
import {
  getSupplier,
  selectRecommendedPhotographer,
} from '@bridebook/web/app-basic/lib/supplier/selectors';
import { useSelector } from '@bridebook/web/app-basic/lib/utils';
import { noop } from 'remeda';
import RecommendedPhotographerComp from '@bridebook/web/app-basic/components/supplier/sections/recommended-photographer/recommended-photographer';
import { useMarket } from '@bridebook/web/app-shared/lib/i18n/hooks/use-market';
import { useSupplierAccordion } from '../hooks/use-supplier-accordion';
import { useSupplierCard } from '../hooks/use-supplier-card';

const RecommendedPhotographer = () => {
  const supplier = useSelector(getSupplier);
  const photographer = useSelector(selectRecommendedPhotographer);
  const isMobile = useSelector(getIsMobile);
  const accordionProps = useSupplierAccordion();
  const supplierCardProps = useSupplierCard();
  const market = useMarket();

  if (!supplier || !photographer) return null;

  return (
    <RecommendedPhotographerComp
      accordionProps={accordionProps}
      add={noop}
      remove={noop}
      supplier={supplier}
      photographer={photographer}
      isMobile={isMobile}
      supplierCardProps={supplierCardProps}
      market={market}
    />
  );
};

export default RecommendedPhotographer;
